import { InjectionToken } from '@angular/core';

export const ENABLE_TOKEN_SERVICE_INJECTION_TOKEN = new InjectionToken<boolean>('EnableTokenService');
